Object.defineProperty(Object.prototype, 'merge', {
    value: function (b) {
        return Object.assign({}, this, b);
    },
    writable: true,
    configurable: true,
    enumerable: false
});

HTMLFormElement.prototype.serializeObject = function () {
    let object = Object.fromEntries(new FormData(this).entries());
     
    let checkboxes = this.querySelectorAll('input[type=checkbox]');
    checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
            object[checkbox.name || checkbox.id] = checkbox.value;
        }
    });

    let multiSelect = this.querySelectorAll('select[multiple]');
    multiSelect.forEach(select => {
        object[select.name || select.id] = Array.from(select.options).filter(o => o.selected).map(o => o.value || o.text);
    });

    return object;
}

DOMTokenList.prototype.toggleIf = function (condition, token) {
    if (condition) {
        this.add(token);
    } else {
        this.remove(token);
    }
}